import { LinkBox, LinkOverlay } from '@chakra-ui/react';
import React from 'react';

export default function SocialButton({children, label, href }) {
  return (
    <LinkBox boxSize={"40px"}>
      <LinkOverlay href={href} isExternal>
        {children}
      </LinkOverlay>
    </LinkBox>
  );
};
